import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './EmptyStateInfo.module.scss';
import usePresenter from './EmptyStateInfo.presenter';
import getProps from './EmptyStateInfo.props';
import { EmptyStateInfoCombinedProps } from './types';

const EmptyStateInfo: React.FC<EmptyStateInfoCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.emptyStateInfo;

  return (
    <div className={cx(currentStyle, className)}>
      <Text
        className={cx(styles.text, classes?.text)}
        {...internalProps.text}
        {...text}
      />
    </div>
  );
};

export default EmptyStateInfo;
